var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPluslogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 370,
    zoomAndPan: "magnify",
    viewBox: "0 0 277.5 70.499998",
    height: 94,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2023d7161e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.730469 0 L 68.144531 0 L 68.144531 67.675781 L 0.730469 67.675781 Z M 0.730469 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b191197e11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.601562 32.664062 C 13.433594 30.785156 0.597656 20.007812 0.730469 3.679688 L 0.742188 3.175781 C 0.75 2.8125 0.769531 2.414062 0.792969 2.191406 L 1.0625 0 L 7.457031 0 C 18.324219 0 28.046875 5.871094 33.203125 15.34375 C 32.027344 16.800781 30.976562 18.355469 30.03125 19.984375 L 29.371094 18.640625 C 25.242188 10.214844 16.84375 4.976562 7.457031 4.976562 L 5.714844 4.976562 C 6.191406 17.765625 16.574219 26.261719 26.417969 27.753906 L 26.65625 27.789062 L 25.601562 32.660156 M 36.886719 45.933594 L 38.707031 45.933594 C 54.9375 45.933594 68.140625 32.730469 68.140625 16.5 L 68.140625 8.621094 L 61.339844 8.621094 C 45.109375 8.621094 31.902344 21.828125 31.902344 38.058594 L 31.902344 67.492188 L 36.878906 67.492188 Z M 36.886719 38.058594 C 36.886719 24.574219 47.859375 13.597656 61.34375 13.597656 L 63.164062 13.597656 L 63.164062 16.5 C 63.164062 29.984375 52.191406 40.957031 38.707031 40.957031 L 36.886719 40.957031 Z M 36.886719 38.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "28caa0bea5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.667969 4.050781 L 86.808594 4.050781 L 86.808594 29.378906 L 75.667969 29.378906 Z M 75.667969 4.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8b97d0f09e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.722656 10.125 L 78.371094 10.125 L 78.371094 4.15625 L 83.335938 4.15625 L 83.335938 10.125 L 86.621094 10.125 L 86.621094 13.480469 L 83.335938 13.480469 L 83.335938 23.636719 C 83.335938 25.054688 84.121094 25.539062 85.238281 25.539062 C 85.871094 25.539062 86.730469 25.503906 86.730469 25.503906 L 86.730469 29.234375 C 86.730469 29.234375 85.570312 29.308594 83.558594 29.308594 C 81.09375 29.308594 78.367188 28.339844 78.367188 24.71875 L 78.367188 13.480469 L 75.722656 13.480469 Z M 75.722656 10.125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0267f2d492"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.214844 2.53125 L 106.691406 2.53125 L 106.691406 29.378906 L 89.214844 29.378906 Z M 89.214844 2.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "440b74ca10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94.304688 12.628906 L 94.417969 12.628906 C 95.800781 10.613281 97.371094 9.605469 99.976562 9.605469 C 103.933594 9.605469 106.582031 12.589844 106.582031 16.769531 L 106.582031 29.273438 L 101.511719 29.273438 L 101.511719 17.511719 C 101.511719 15.457031 100.316406 14.003906 98.1875 14.003906 C 95.945312 14.003906 94.304688 15.796875 94.304688 18.410156 L 94.304688 29.273438 L 89.234375 29.273438 L 89.234375 2.585938 L 94.3125 2.585938 Z M 94.304688 12.628906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4a59cb7e94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.722656 2.585938 L 114.800781 2.585938 L 114.800781 7.140625 L 109.722656 7.140625 Z M 109.722656 10.128906 L 114.800781 10.128906 L 114.800781 29.273438 L 109.722656 29.273438 Z M 109.722656 10.128906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0b44db0aa0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.820312 9.496094 L 133.917969 9.496094 L 133.917969 29.886719 L 116.820312 29.886719 Z M 116.820312 9.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "709a08b310"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.890625 23.078125 L 121.589844 23.078125 C 121.925781 25.277344 123.496094 26.25 125.773438 26.25 C 128.011719 26.25 129.28125 25.390625 129.28125 24.042969 C 129.28125 22.21875 126.855469 22.03125 124.242188 21.507812 C 120.808594 20.835938 117.449219 19.90625 117.449219 15.722656 C 117.449219 11.582031 120.882812 9.605469 125.25 9.605469 C 130.285156 9.605469 133.085938 12.105469 133.457031 15.949219 L 128.871094 15.949219 C 128.648438 13.894531 127.339844 13.152344 125.175781 13.152344 C 123.199219 13.152344 121.890625 13.894531 121.890625 15.277344 C 121.890625 16.917969 124.425781 17.070312 127.152344 17.628906 C 130.363281 18.300781 133.90625 19.195312 133.90625 23.671875 C 133.90625 27.515625 130.621094 29.832031 125.84375 29.832031 C 120.285156 29.832031 117.1875 27.144531 116.890625 23.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3dd691152c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.65625 34.179688 L 101.765625 34.179688 L 101.765625 67.113281 L 75.65625 67.113281 Z M 75.65625 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d3ca880bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.722656 34.246094 L 90.125 34.246094 C 93.933594 34.246094 96.773438 35.351562 98.707031 37.320312 C 100.539062 39.207031 101.640625 41.773438 101.640625 44.800781 C 101.640625 50.996094 97.554688 55.167969 90.671875 55.167969 L 82.605469 55.167969 L 82.605469 67.050781 L 75.722656 67.050781 Z M 82.605469 49.753906 L 89.488281 49.753906 C 92.976562 49.753906 94.808594 47.828125 94.808594 44.847656 C 94.808594 41.773438 92.882812 40.027344 89.582031 40.027344 L 82.605469 40.027344 Z M 82.605469 49.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5edceb9c91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99.539062 34.179688 L 129.503906 34.179688 L 129.503906 67.113281 L 99.539062 67.113281 Z M 99.539062 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a1d00cbe3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111 34.246094 L 117.886719 34.246094 L 129.445312 67.050781 L 122.515625 67.050781 L 120.316406 60.074219 L 108.480469 60.074219 L 106.324219 67.050781 L 99.578125 67.050781 Z M 110.039062 54.980469 L 118.707031 54.980469 L 115.773438 45.535156 C 115.226562 43.789062 114.445312 40.488281 114.445312 40.488281 L 114.351562 40.488281 C 114.351562 40.488281 113.523438 43.789062 112.972656 45.535156 Z M 110.039062 54.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63e933d9cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132.175781 34.179688 L 158.726562 34.179688 L 158.726562 67.113281 L 132.175781 67.113281 Z M 132.175781 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3bd95854a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132.207031 34.246094 L 138.949219 34.246094 L 149.867188 52.550781 C 150.925781 54.34375 152.160156 57.136719 152.160156 57.136719 L 152.253906 57.136719 C 152.253906 57.136719 152.070312 53.742188 152.070312 51.449219 L 152.070312 34.246094 L 158.632812 34.246094 L 158.632812 67.050781 L 152.203125 67.050781 L 141.007812 48.929688 C 139.953125 47.1875 138.667969 44.386719 138.667969 44.386719 L 138.578125 44.386719 C 138.578125 44.386719 138.761719 47.828125 138.761719 50.121094 L 138.761719 67.050781 L 132.207031 67.050781 Z M 132.207031 34.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "40dd3602b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161.980469 34.246094 L 188.359375 34.246094 L 188.359375 39.84375 L 161.980469 39.84375 Z M 171.84375 39.84375 L 178.496094 39.84375 L 178.496094 67.050781 L 171.84375 67.050781 Z M 171.84375 39.84375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "37d0a656e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 191.660156 34.179688 L 217.769531 34.179688 L 217.769531 67.113281 L 191.660156 67.113281 Z M 191.660156 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2fd128dc3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 191.710938 34.246094 L 206.757812 34.246094 C 213.085938 34.246094 217.308594 37.917969 217.308594 43.375 C 217.308594 47.230469 215.519531 50.167969 211.300781 51.3125 L 211.300781 51.449219 C 214.328125 52.320312 215.886719 54.0625 216.300781 58.058594 C 216.761719 62.691406 216.574219 66.226562 217.722656 66.726562 L 217.722656 67.050781 L 211.34375 67.050781 C 210.519531 66.679688 210.425781 63.011719 210.152344 59.476562 C 209.878906 55.902344 207.859375 53.882812 203.730469 53.882812 L 198.363281 53.882812 L 198.363281 67.050781 L 191.710938 67.050781 Z M 198.363281 48.742188 L 205.425781 48.742188 C 209.050781 48.742188 210.839844 46.859375 210.839844 44.246094 C 210.839844 41.585938 209.144531 39.613281 205.609375 39.613281 L 198.363281 39.613281 Z M 198.363281 48.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9aa87f5609"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 218.214844 34.179688 L 246.84375 34.179688 L 246.84375 67.113281 L 218.214844 67.113281 Z M 218.214844 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e33f23c5b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 229.246094 54.386719 L 218.324219 34.246094 L 225.574219 34.246094 L 230.527344 43.972656 C 231.535156 45.945312 232.6875 48.652344 232.6875 48.652344 L 232.777344 48.652344 C 232.777344 48.652344 234.015625 45.945312 234.980469 43.972656 L 239.839844 34.246094 L 246.808594 34.246094 L 235.890625 54.386719 L 235.890625 67.050781 L 229.246094 67.050781 Z M 229.246094 54.386719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f32bcb9669"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 249.398438 44.3125 L 275.964844 44.3125 L 275.964844 49.746094 L 249.398438 49.746094 Z M 249.398438 44.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75839005bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 259.964844 33.734375 L 265.398438 33.734375 L 265.398438 60.300781 L 259.964844 60.300781 Z M 259.964844 33.734375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2023d7161e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b191197e11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#598a56",
    d: "M 0.730469 0 L 68.144531 0 L 68.144531 67.414062 L 0.730469 67.414062 Z M 0.730469 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#28caa0bea5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8b97d0f09e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 0 L 136.449219 0 L 136.449219 32.417969 L 73.132812 32.417969 Z M 73.132812 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0267f2d492)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#440b74ca10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 0 L 136.449219 0 L 136.449219 32.417969 L 73.132812 32.417969 Z M 73.132812 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a59cb7e94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 0 L 136.449219 0 L 136.449219 32.417969 L 73.132812 32.417969 Z M 73.132812 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0b44db0aa0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#709a08b310)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 0 L 136.449219 0 L 136.449219 32.417969 L 73.132812 32.417969 Z M 73.132812 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3dd691152c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d3ca880bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 31.660156 L 249.367188 31.660156 L 249.367188 69.636719 L 73.132812 69.636719 Z M 73.132812 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5edceb9c91)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a1d00cbe3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 31.660156 L 249.367188 31.660156 L 249.367188 69.636719 L 73.132812 69.636719 Z M 73.132812 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63e933d9cf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3bd95854a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 31.660156 L 249.367188 31.660156 L 249.367188 69.636719 L 73.132812 69.636719 Z M 73.132812 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#40dd3602b8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 31.660156 L 249.367188 31.660156 L 249.367188 69.636719 L 73.132812 69.636719 Z M 73.132812 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#37d0a656e7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2fd128dc3c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 31.660156 L 249.367188 31.660156 L 249.367188 69.636719 L 73.132812 69.636719 Z M 73.132812 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9aa87f5609)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e33f23c5b1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e2e2e",
    d: "M 73.132812 31.660156 L 249.367188 31.660156 L 249.367188 69.636719 L 73.132812 69.636719 Z M 73.132812 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f32bcb9669)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#598a56",
    d: "M 249.398438 44.3125 L 275.96875 44.3125 L 275.96875 49.746094 L 249.398438 49.746094 Z M 249.398438 44.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75839005bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#598a56",
    d: "M 259.964844 60.300781 L 259.964844 33.730469 L 265.398438 33.730469 L 265.398438 60.300781 Z M 259.964844 60.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluslogo);
export default __webpack_public_path__ + "static/media/pluslogo.a1dfd7b0211bf4d23c968326388074a8.svg";
export { ForwardRef as ReactComponent };